<template>
  <v-card ref="list">
    <v-card-title>
      <p class="headline" style="padding-left: 16px; padding-top: 16px">
        <b>{{ size }} </b>{{ title }}
      </p>
      <v-spacer></v-spacer>
      <v-text-field
        append-icon="search"
        label="Search"
        single-line
        hide-details
        v-model="search"
      ></v-text-field>
    </v-card-title>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="items"
      :search="search"
      :loading="loading"
      :select-all="false"
      hide-actions
      item-key="id"
    >
      <template slot="items" slot-scope="props">
        <item-table
          :item="props.item"
          :selected="props.selected"
          @expand="props.expanded = !props.expanded"
        ></item-table>
      </template>
      <template slot="expand" slot-scope="props">
        <person-item
          v-for="person in props.item.people"
          :person="person"
          :key="person.id"
          :style="{
            width: width - 32 + 'px',
            position: 'sticky',
            left: '16px',
          }"
        ></person-item>
      </template>
      <template v-if="loading" slot="no-data">
        <v-alert :value="true" color="info" icon="info">
          Sorry, nothing to display here :(
        </v-alert>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import ItemTable from "./campamento/ItemTable";
import ExpandedItemTable from "./campamento/ExpandedItemTable";
import PersonItem from "./personas/PersonItem";

export default {
  components: {
    PersonItem,
    ExpandedItemTable,
    ItemTable,
  },
  name: "campamentos",
  data() {
    return {
      width: 0,
      loading: false,
      search: "",
      selected: [],
      title: "Inscripciones Verano 2025",
      headers: [
        {
          text: "Recibos",
          align: "left",
          sortable: false,
          value: "id",
        },
        { text: "date", value: "date" },
        { text: "Email", value: "email" },
        { text: "Teléfono", value: "phone" },
        { text: "Precio", value: "price" },
        { text: "Estado", value: "status" },
        { text: "Acciones", value: "name", sortable: false },
      ],
      items: [],
    };
  },
  firestore() {
    return {
      items: this.$db
        .collection("forms")
        .doc("inscripciones")
        .collection("answers")
        //.where("status", "==", "REGISTRERED"), //Pagado REGISTRERED
    };
  },
  watch: {
    items() {
      this.loading = false;
    },
  },
  computed: {
    size() {
      return this.items.length !== 0 ? this.items.length : "";
    },
  },
  methods: {
    handleResize() {
      console.log("try");
      this.width = this.$refs.list.$el.offsetWidth;
    },
  },
  mounted: function () {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped>
</style>